import React from "react";
import PropTypes from "prop-types";
import { bridgeTextParts } from "../utils/bridgeText";
import { cn } from "../utils/classNames";

const BridgeText = ({ text = "", titles = [], titleClassName = "" }) => (
  <>
    {bridgeTextParts(text, titles).map((part, index) => (
      part.isTitle ? (
        <em key={`${part.text}-${index}`} className={cn("font-medium italic", titleClassName)}>
          {part.text}
        </em>
      ) : (
        <React.Fragment key={`${part.text}-${index}`}>{part.text}</React.Fragment>
      )
    ))}
  </>
);

BridgeText.propTypes = {
  text: PropTypes.string,
  titles: PropTypes.arrayOf(PropTypes.string),
  titleClassName: PropTypes.string,
};

export default BridgeText;
